(() => {
  const attach = root => {
    const menus = [...root.querySelectorAll('[data-erya-desktop-menu]')];
    menus.forEach(menu => {
      if (menu.dataset.eryaBound) return;
      menu.dataset.eryaBound = 'true';
      let hoverTimer;
      const openAfterHover = () => {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => {
          if (menu.isConnected && matchMedia('(hover:hover) and (pointer:fine)').matches) menu.open = true;
        }, 140);
      };
      menu.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') openAfterHover();
      });
      menu.addEventListener('pointerleave', () => {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => {
          if (!menu.contains(document.activeElement)) menu.open = false;
        }, 180);
      });
      menu.addEventListener('toggle', () => {
        if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
        menu.querySelector('summary').setAttribute('aria-expanded', String(menu.open));
      });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.open) {
          event.preventDefault();
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
    });
  };
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-erya-desktop-menu][open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => attach(document), {once:true});
  else attach(document);
  document.addEventListener('shopify:section:load', event => attach(event.target));
})();

if (!customElements.get('erya-menu-preview')) {
  customElements.define('erya-menu-preview', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.target = this.querySelector('[data-menu-preview-target]');
      if (!this.target) return;
      const {signal} = this.abort;
      const show = event => {
        const link = event.target.closest('[data-menu-preview]');
        if (!link || !this.contains(link) || this.target.contains(link)) return;
        if (event.type === 'pointerover' && event.pointerType !== 'mouse') return;
        this.show(link);
      };
      this.addEventListener('pointerover', show, {signal});
      this.addEventListener('focusin', show, {signal});
    }
    async show(link) {
      const url = link.dataset.menuPreview;
      this.requested = url;
      this.target.href = link.dataset.previewHref || link.href;
      const label = this.target.querySelector('[data-menu-preview-label]');
      if (label) label.textContent = link.dataset.menuPreviewTitle;
      this.querySelectorAll('[data-menu-preview]').forEach(item => item.classList.toggle('is-preview-active', item === link));
      if (url === this.current) return;
      const image = new Image();
      image.src = url;
      image.alt = link.dataset.menuPreviewAlt || link.textContent.trim();
      image.className = 'erya-menu-preview-image';
      try { await image.decode(); } catch { return; }
      if (!this.isConnected || this.requested !== url) return;
      this.current = url;
      const previous = this.target.querySelector('.erya-menu-preview-image');
      this.target.append(image);
      requestAnimationFrame(() => image.classList.add('is-visible'));
      setTimeout(() => previous?.remove(), 320);
    }
    disconnectedCallback() { this.abort?.abort(); this.requested = null; }
  });
}
